// ============================================
// NOVANEXT — Contenu du site (client-centric)
// ============================================

// 5 pôles cœur de métier
export const SERVICES = [
  {
    id: "proprete",
    icon: "Sparkles",
    title: "Propreté & Hygiène",
    tagline: "Vous disposez d'espaces impeccables au quotidien",
    image: "https://customer-assets.emergentagent.com/job_services-hub-60/artifacts/vhfvdhfs_Propret%C3%A9%20%26%20Hygi%C3%A8ne.jpg",
    features: [
      "Nettoyage professionnel quotidien de vos locaux",
      "Vitrerie, façades et surfaces vitrées",
      "Désinfection, bionettoyage, plans hygiène",
      "Nettoyage industriel et post-chantier",
      "Traitement des sols (cristallisation, cirage)",
      "Autolaveuse et matériel professionnel",
    ],
  },
  {
    id: "maintenance",
    icon: "Wrench",
    title: "Maintenance Multitechnique",
    tagline: "Vous préservez la valeur et la performance de votre patrimoine",
    image: "https://customer-assets.emergentagent.com/job_services-hub-60/artifacts/i41ej6ad_Maintenance%20Multitechnique.jpeg",
    features: [
      "Maintenance préventive et corrective",
      "Électricité, éclairage, courants faibles",
      "Plomberie, CVC, climatisation",
      "Serrurerie, contrôle d'accès",
      "Gestion technique des bâtiments (GTB)",
      "Astreinte technique 7j/7 · 24h/24",
    ],
  },
  {
    id: "travaux",
    icon: "Hammer",
    title: "Travaux & Rénovation",
    tagline: "Vous rénovez vos espaces sans multiplier les prestataires",
    image: "https://customer-assets.emergentagent.com/job_services-hub-60/artifacts/kub77dwt_Travaux%20%26%20R%C3%A9novation.jpeg",
    features: [
      "Rénovation intérieure de bureaux et locaux",
      "Peinture, revêtements de sols et murs",
      "Cloisons, faux-plafonds, menuiseries",
      "Mise aux normes électriques et plomberie",
      "Coordination tous corps de métier",
      "Nettoyage fin de chantier",
    ],
  },
  {
    id: "espaces-verts",
    icon: "Trees",
    title: "Espaces Verts",
    tagline: "Vous offrez un cadre de vie soigné à vos collaborateurs et visiteurs",
    image: "https://customer-assets.emergentagent.com/job_services-hub-60/artifacts/r7nptwxh_Espaces%20Verts.jpg",
    features: [
      "Entretien des espaces verts et jardins",
      "Tonte, taille, désherbage",
      "Plantations et aménagements paysagers",
      "Arrosage automatique",
      "Entretien durable et raisonné",
      "Matériel professionnel",
    ],
  },
  {
    id: "multiservices",
    icon: "Users",
    title: "Multiservices",
    tagline: "Des interventions techniques et opérationnelles du quotidien pour garantir le bon fonctionnement de vos locaux et répondre rapidement à vos besoins ponctuels.",
    image: "https://customer-assets.emergentagent.com/job_services-hub-60/artifacts/1hqfi6pr_Multiservices.jpeg",
    features: [
      "Petites réparations",
      "Interventions techniques de premier niveau",
      "Montage et installation de mobilier",
      "Manutentions ponctuelles",
      "Débarras de locaux",
      "Débarras de zones de chantier",
    ],
    conclusion: "Parce que chaque détail compte, nos équipes interviennent rapidement pour assurer la continuité de votre activité et préserver la qualité de vos espaces.",
  },
];

// Services complémentaires (rubrique séparée)
export const SERVICES_COMPLEMENTAIRES = [
  {
    id: "consommables-sanitaires",
    icon: "Package",
    title: "Fourniture de consommables sanitaires",
    description: "Papier toilette, essuie-mains, savon, produits d'entretien et consommables d'hygiène — approvisionnement régulier de vos sanitaires.",
  },
  {
    id: "consommables-restauration",
    icon: "Coffee",
    title: "Gestion des consommables",
    description: "Café, thé, sucre, gobelets, capsules, fontaines à eau — un approvisionnement fluide pour vos espaces de restauration.",
  },
  {
    id: "debarras",
    icon: "Truck",
    title: "Débarras & gestion des déchets",
    description: "Débarras de zones de chantier, évacuation de gravats, tri sélectif, gestion des encombrants et déchets d'activité.",
  },
  {
    id: "manutention",
    icon: "Boxes",
    title: "Petites manutentions",
    description: "Déménagements internes, réagencements de bureaux, montage/démontage de mobilier, manutention légère à la demande.",
  },
];

// Cartes valeurs — preuves concrètes de qualité (spec client-centric)
export const VALEURS = [
  {
    icon: "BadgeCheck",
    title: "Contrôle qualité systématique",
    description:
      "Chaque intervention fait l'objet d'une vérification afin de garantir un niveau de qualité constant.",
  },
  {
    icon: "UserCheck",
    title: "Un pilotage centralisé",
    description:
      "Un référent unique coordonne l'ensemble de vos prestations : moins de coordination, plus de résultats.",
  },
  {
    icon: "Zap",
    title: "Réactivité opérationnelle",
    description:
      "Nos équipes interviennent rapidement afin de limiter tout impact sur votre activité.",
  },
  {
    icon: "TrendingUp",
    title: "Suivi & amélioration continue",
    description:
      "Des contrôles réguliers permettent d'adapter nos prestations selon vos besoins.",
  },
];

// Notre engagement qualité — 6 étapes de la démarche qualité
export const METHODOLOGIE = [
  { step: "01", title: "Audit initial", description: "Compréhension de vos besoins, visite technique et évaluation de votre environnement." },
  { step: "02", title: "Planification", description: "Élaboration du plan d'action, définition des moyens et calendrier des interventions." },
  { step: "03", title: "Réalisation", description: "Mise en œuvre des équipes qualifiées et coordination des prestations sur site." },
  { step: "04", title: "Contrôle qualité systématique", description: "Vérifications terrain, audits internes et indicateurs de performance mesurés." },
  { step: "05", title: "Validation avec le client", description: "Point de suivi, retour d'expérience et validation conjointe du niveau de service." },
  { step: "06", title: "Amélioration continue", description: "Ajustements des prestations et évolution de la qualité de service dans la durée." },
];

// Ce que vous gagnez concrètement — LISTE CANONIQUE (source unique de vérité)
// Affichée en intégralité uniquement sur /pourquoi-nous.
// L'Accueil n'en affiche qu'un extrait (les 3 premiers) + lien vers /pourquoi-nous.
export const ENGAGEMENTS = [
  { icon: "UserCheck", title: "Un interlocuteur dédié", description: "Un chef de site unique, disponible et réactif, pilote l'ensemble de vos prestations." },
  { icon: "Clock", title: "Une réponse sous 24h ouvrées", description: "Chaque demande de devis reçoit une proposition claire et chiffrée en moins d'un jour ouvré." },
  { icon: "BadgeCheck", title: "Un contrôle qualité continu", description: "Audits internes réguliers et indicateurs partagés vous garantissent un niveau de service constant." },
  { icon: "Settings", title: "Des prestations sur-mesure", description: "Chaque contrat est dimensionné à votre site — jamais standardisé, ni surdimensionné." },
  { icon: "Handshake", title: "Une relation de confiance durable", description: "Un accompagnement local et transparent, pensé pour construire un partenariat sur la durée." },
];

export const SECTEURS = [
  { title: "Bureaux & Tertiaire", icon: "Building2" },
  { title: "Copropriétés & Syndics", icon: "Home" },
  { title: "Commerces & Retail", icon: "Store" },
  { title: "Hôtels & Restauration", icon: "Hotel" },
  { title: "Collectivités & Administrations", icon: "Landmark" },
  { title: "Établissements de Santé", icon: "Cross" },
  { title: "Industries & Manufacturing", icon: "Factory" },
  { title: "Entrepôts & Logistique", icon: "Warehouse" },
  { title: "Résidences & Habitat", icon: "Building" },
];

// FAQ orientée besoin client
export const FAQ = [
  { q: "Intervenez-vous en urgence ?", a: "Oui. Une astreinte 7j/7 · 24h/24 est active pour les fuites, sinistres, pannes électriques, serrurerie et nettoyage post-sinistre." },
  { q: "Travaillez-vous le week-end ?", a: "Oui. Vos interventions peuvent être planifiées le samedi, le dimanche ou en horaires décalés, selon les contraintes de votre site." },
  { q: "Proposez-vous des contrats d'entretien ?", a: "Oui. Vous bénéficiez de contrats d'entretien annuels adaptés à chaque site : fréquences, périmètre, indicateurs et niveaux de service définis contractuellement." },
  { q: "Vos équipes sont-elles encadrées ?", a: "Toujours. Chaque site est piloté par un chef de site unique, disponible et responsable de la qualité d'exécution au quotidien." },
  { q: "Comment contrôlez-vous la qualité ?", a: "Contrôles terrain réguliers, audits internes programmés, indicateurs de performance mesurés et reporting périodique partagé avec vous." },
  { q: "Dans quelles zones intervenez-vous ?", a: "Parlez-nous de votre besoin. Chaque demande est étudiée selon la nature, la localisation et les exigences de la mission — nos équipes vous proposent ensuite une solution adaptée." },
  { q: "Puis-je regrouper plusieurs prestations dans un contrat unique ?", a: "Absolument. C'est justement l'intérêt du Facility Management : vous regroupez propreté, maintenance, espaces verts, multiservices et services complémentaires au sein d'un seul contrat, avec un pilotage centralisé." },
  { q: "Assurez-vous également la fourniture de consommables ?", a: "Oui. En complément de vos prestations principales, vous pouvez confier l'approvisionnement régulier des consommables sanitaires, produits d'entretien, café, capsules et fontaines à eau." },
];
;
